
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[articleUrl]",
      function () {
        return require("private-next-pages/articles/[articleUrl]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/[articleUrl]"])
      });
    }
  